import { useSystemMaintenance } from 'Providers/SystemMaintenanceProvider'
import styled from 'styled-components'
import './maintenance-mode.css'

const Container = styled.div`
  opacity: 1;
  transition-duration: 0.25s;
  transition-timing-function: ease-in;
  transition-property: opacity;
  height: 70px;
  display: flex;
  align-items: center;
`
const Background = styled.div`
  background-color: var(--nsw-brand-dark);
  color: white;
  font-weight: bolder;
  font-size: 23px;
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  display: flex;
`

export default function MaintenanceInfobox() {
  const { isInMaintenanceWindow, message } = useSystemMaintenance()
  return isInMaintenanceWindow() ? (
    <Container className="maintenance-warning">
      <Background className="maintenance-bg">
        <p>
          {message
            ? message
            : 'Byte is undergoing maintenance. Submissions are currently disabled'}
        </p>
      </Background>
    </Container>
  ) : null
}
